import 'css-chunksrc/client/pages/projectPage/documentsPage/reportsPage/filterForm/resourcesFilter/resource/styles.scss';export default {
  "resource": "_resource_1ah7s_1",
  "avatar": "_avatar_1ah7s_9",
  "name": "_name_1ah7s_16"
};